import React from "react";
import { View, Text, TouchableOpacity, ScrollView, Linking, Image } from "react-native";
import moment from "moment";
import { ODSIcon } from "../../atoms/ODSIcon";
import ODSButton from "../../atoms/ODSButton";
import { styles } from "./styles";
import { ICategoryType, IMaintenanceItem, IRoomType } from "./types";

interface Props {
  item: IMaintenanceItem;
  isExpanded: boolean;
  onPress: () => void;
  onEdit: () => void;
  roomTypes: IRoomType[];
  categoryTypes: ICategoryType[];
}

const StatusBadge = ({ status }: { status: string }) => {
  const config =
    {
      Completed: { color: "#059669", bg: "#D1FAE5" },
      pending: { color: "#D97706", bg: "#FEF3C7" },
      PENDING: { color: "#DC2626", bg: "#FEE2E2" }
    }[status] || { color: "#6B7280", bg: "#F3F4F6" };

  return (
    <View style={[styles.statusBadge, { backgroundColor: config.bg }]}>
      <Text style={[styles.statusBadgeText, { color: config.color }]}>
       {status=="inprogress"?"In progress": status}
      </Text>
    </View>
  );
};

const LabelValue = ({
  label,
  value,
  icon
}: {
  label: string;
  value: string;
  icon?: string;
}) => (
  <View style={styles.labelValueContainer}>
    <Text style={styles.label}>{label}</Text>
    <View style={styles.valueRow}>
      {icon && <ODSIcon icon={icon} size={12} style={{ marginRight: 4 }} />}
      <Text style={styles.value}>{value}</Text>
    </View>
  </View>
);

const MaintenanceCard = ({
  item,
  isExpanded,
  onPress,
  onEdit,
  roomTypes,
  categoryTypes
}: Props) => {
  const categoryName =
    categoryTypes.find(
      (x) => x.open_flow_maintenance_issue_category_id == item.category_id
    )?.name || "—";

  const roomName =
    roomTypes.find(
      (x) => x.open_flow_maintenance_issue_room_type_id == item.room_type_id
    )?.name || "—";

  return (
    <View style={styles.cardContainer}>
      <TouchableOpacity onPress={onPress} style={styles.cardHeader}>
        <View style={styles.titleRow}>
          <Text style={styles.cardTitle}>{item.title}</Text>

          <View style={styles.statusRow}>
            <StatusBadge status={item.status} />
            <View
              style={[
                styles.arrowIcon,
                { transform: [{ rotate: isExpanded ? "180deg" : "0deg" }] }
              ]}
            >
              <ODSIcon icon="Frame-3" size={16} color="#64748B" />
            </View>
          </View>
        </View>

        <View style={styles.metaRow}>
          <View style={styles.metaColumn}>
            <LabelValue
              label="Date Reported"
              value={moment(item.date_opened).format("DD/MM/YYYY")}
              icon="Calendar"
            />
            <LabelValue label="Room" value={roomName} icon="Location" />
          </View>

          <View style={styles.metaColumn}>
            <LabelValue
              label="Category"
              value={categoryName}
              icon="Category"
            />
            <LabelValue
              label="Issue ID"
              value={`#${item.open_flow_maintenance_issue_id}`}
              icon="ID"
            />
          </View>
        </View>
      </TouchableOpacity>

      {isExpanded && (
        <View style={styles.expandedSection}>
          <View style={styles.descriptionBlock}>
            <Text style={styles.descriptionHeading}>Description</Text>
            <Text style={styles.descriptionText}>
              {item.description || "No description provided"}
            </Text>
          </View>

          {(item.images.length > 0 || item.videos.length > 0) && (
            <View style={{ marginBottom: 20 }}>
              <Text style={styles.attachmentHeading}>
                Attachments ({item.images.length + item.videos.length})
              </Text>

              <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                {item.images.map((img, i) => (
                  <TouchableOpacity
                    key={i}
                    style={styles.attachmentBox}
                    onPress={() => Linking.openURL(img)}
                    activeOpacity={0.8}
                  >
                    <Image
                      source={{ uri: img }}
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: 8,
                        backgroundColor: "#E5E7EB"
                      }}
                      resizeMode="cover"
                    />
                    <Text style={styles.attachmentLabel}>Image {i + 1}</Text>
                  </TouchableOpacity>
                ))}


                {item.videos.map((v, i) => (
                  <View key={i} style={styles.attachmentBox}>
                    <ODSIcon icon="Video" size={24} color="#EF4444" />
                    <Text style={styles.attachmentLabel}>Video {i + 1}</Text>
                  </View>
                ))}
              </ScrollView>
            </View>
          )}

        {item?.status=="completed"?null:  <View style={styles.actionRow}>
            <ODSButton
              rIcon="TB-Edit"
              type="primary"
              onPress={onEdit}
              restStyle={styles.editButton}
            >
              Edit Issue
            </ODSButton>
          </View>}
        </View>
      )}
    </View>
  );
};

export default MaintenanceCard;
